export const weatherIcons = [
  // Day Icons
  {
    id: "01d",
    icon: "/assets/img/weather-icons/icon-sunny.svg",
    description: "clear sky",
  },
  {
    id: "02d",
    icon: "/assets/img/weather-icons/icon-clouds.svg",
    description: "few clouds",
  },
  {
    id: "03d",
    icon: "/assets/img/weather-icons/icon-scattered-clouds.svg",
    description: "scattered clouds",
  },
  {
    id: "04d",
    icon: "/assets/img/weather-icons/icon-broken-clouds.svg",
    description: "broken clouds",
  },
  {
    id: "09d",
    icon: "/assets/img/weather-icons/icon-shower-rain.svg",
    description: "shower rain",
  },
  {
    id: "10d",
    icon: "/assets/img/weather-icons/icon-rain.svg",
    description: "rain",
  },
  {
    id: "11d",
    icon: "/assets/img/weather-icons/icon-thunderstorm.svg",
    description: "thunderstorm",
  },
  {
    id: "13d",
    icon: "/assets/img/weather-icons/icon-snow.svg",
    description: "snow",
  },
  {
    id: "50d",
    icon: "/assets/img/weather-icons/icon-mist.svg",
    description: "mist",
  },
  // Night Icons
  {
    id: "01n",
    icon: "/assets/img/weather-icons/icon-night-clear.svg",
    description: "clear sky",
  },
  {
    id: "02n",
    icon: "/assets/img/weather-icons/icon-night-cloudy.svg",
    description: "few clouds",
  },
  {
    id: "03n",
    icon: "/assets/img/weather-icons/icon-night-scatted-clouds.svg",
    description: "scattered clouds",
  },
  {
    id: "04n",
    icon: "/assets/img/weather-icons/icon-night-broken-clouds.svg",
    description: "broken clouds",
  },
  {
    id: "09n",
    icon: "/assets/img/weather-icons/icon-night-shower-rain.svg",
    description: "shower rain",
  },
  {
    id: "10n",
    icon: "/assets/img/weather-icons/icon-night-rain.svg",
    description: "rain",
  },
  {
    id: "11n",
    icon: "/assets/img/weather-icons/icon-night-thunderstorm.svg",
    description: "thunderstorm",
  },
  {
    id: "13n",
    icon: "/assets/img/weather-icons/icon-night-snow.svg",
    description: "snow",
  },
  {
    id: "50n",
    icon: "/assets/img/weather-icons/icon-night-mist.svg",
    description: "mist",
  },
];
